import { useState, useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';

// Peacock components
import { Button, DatePickerInput } from 'pepsico-ds';

// Custom Components
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';
import OktaStatusTable from '@/containers/OnboardingStatus/OktaStatusTable';

// Constants
import { ROUTES } from '@/utils/constants/routesConstants';
import MissingProductListTable from '@/containers/OnboardingStatus/MissingProductListTable';
import DateRangeSelector from '@/components/common/DateRangeSelector/DateRangeSelector';

const MissingProductListView = () => {
  const [dateRange, setDateRange] = useState({
    startDate: new Date(2023, 0, 1), // Jan 1, 2023
    endDate: (() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow;
    })(),
    isValid: true
  });

  const shouldLoadData = useMemo(() => {
    return !!dateRange.startDate && !!dateRange.endDate && dateRange.isValid;
  }, [dateRange]);

  return (
    <div>
      <DateRangeSelector
        onDatesChange={setDateRange}
        initialStartDate={dateRange.startDate}
        initialEndDate={dateRange.endDate}
      />

      {!shouldLoadData ? (
        <div className='text-center p-8'>
          <p>Please select both start and end dates to load the table data.</p>
        </div>
      ) : (
        <div className=''>
          <MissingProductListTable
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
          />
        </div>
      )}
    </div>
  );
};

export default MissingProductListView;
